// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `input[type='search']::-webkit-search-decoration,
::-webkit-search-cancel-button,
::-webkit-search-results-button,
::-webkit-search-results-decoration {
  display: none;
}
input[type='search']:focus {
  --tw-ring-shadow: unset;
}
`, "",{"version":3,"sources":["webpack://./src/components/searchbar/searchbar.css"],"names":[],"mappings":"AAAA;;;;EAIE,aAAa;AACf;AACA;EACE,uBAAuB;AACzB","sourcesContent":["input[type='search']::-webkit-search-decoration,\n::-webkit-search-cancel-button,\n::-webkit-search-results-button,\n::-webkit-search-results-decoration {\n  display: none;\n}\ninput[type='search']:focus {\n  --tw-ring-shadow: unset;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
